<template>
  <div id="app">
    <SideNavbar/>
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav> -->
    <div class="container">
    <router-view/>
    </div>
  </div>
</template>

<script>
import SideNavbar from './components/SideNavbar.vue'
export default{
  name:'App',

  components: { 
    SideNavbar,
     },

}
</script>



<style>
 #app {
  font-family: Raleway, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
 
}
.toasted .primary, .toasted.toasted-primary{
  border-radius: 10px;
  /* background-color: #149b96; */
  background: linear-gradient(127deg, #275395 0%, rgb(22 135 156) 100%);
  font-weight: 600;
  color: #fff;
}

/*nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
} */
</style>
